export default __webpack_public_path__ + "static/media/nightbot.9a6b0a5d.png";